const getImageUrl = (imageId: string): string => {
  // resolve image host based on environment
  const env =
    (typeof window !== 'undefined' && window.zola && window.zola.env) ||
    (typeof process !== 'undefined' && process.env && process.env.ZOLA_ENV);
  return `//${env === 'production' ? '' : 'stage-'}images.zola.com/${imageId}`;
};

export default getImageUrl;
